import moment from "moment";

export interface ISnapshotDiffRow {
  key: string;
  before: string;
  after: string;
  isDifferent: boolean;
}

const ISO_DATE_RE = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}/;

const formatSnapshotValue = (value: unknown): string => {
  if (value === undefined) {
    return "—";
  }
  if (value === null) {
    return "null";
  }
  if (typeof value === "string" && ISO_DATE_RE.test(value)) {
    return moment(value).format("DD/MM/YYYY HH:mm:ss");
  }
  if (typeof value === "object") {
    return JSON.stringify(value);
  }
  return String(value);
};

// Same field lists side by side (as sent by the before/after snapshots on
// each trace) so a caller can render them as a table and highlight the
// rows that actually changed.
export const getSnapshotDiffRows = (before: unknown, after: unknown): ISnapshotDiffRow[] => {
  const beforeObj = before && typeof before === "object" ? (before as Record<string, unknown>) : {};
  const afterObj = after && typeof after === "object" ? (after as Record<string, unknown>) : {};
  const keys = Array.from(new Set([...Object.keys(beforeObj), ...Object.keys(afterObj)])).sort();
  return keys.map((key) => {
    const beforeText = formatSnapshotValue(beforeObj[key]);
    const afterText = formatSnapshotValue(afterObj[key]);
    return { key, before: beforeText, after: afterText, isDifferent: beforeText !== afterText };
  });
};
